module.exports = "/_next/static/images/20e776462e46eecd8dcf83ae6579b4b8-value-proposal-lg-2x.png";